import { useAuth } from '@/contexts/AuthContext';

// Mirrors backend/routes/auth.py ROLES and docs/security/route-role-matrix.md.
// Used only to hide controls the backend would refuse; the backend still
// enforces every check. Change this file together with the matrix.
export const ROLE_LEVELS = {
  admin: 100,
  manager: 75,
  pm: 50,
  viewer: 25,
  requester: 10,
};

// Minimum role per kind of action, as in the route matrix.
export const PERMISSIONS = {
  // Create, edit, reorder and delete items, stories and sprints; ADO sync,
  // import, team links and repository selection.
  editWork: 'pm',
  // AI refine, quality scout, sprint planning, standup and summaries.
  runAi: 'pm',
  // Pull work items from ADO into the local cache.
  pullAdo: 'viewer',
  // Save the ADO connection.
  configureAdo: 'admin',
  // Save notification settings and send a test notification.
  manageNotifications: 'manager',
  // Approve or reject a roadmap change.
  decideRoadmapChange: 'pm',
};

// Capabilities, as ROLE_CAPABILITIES in backend/routes/auth.py. A capability
// is an explicit list of roles, outside the hierarchy; admin holds them all.
export const CAPABILITIES = {
  // Every intake request: the All requests tab, its counts and its Drawer.
  readAllIntake: ['admin', 'manager', 'pm', 'intake_reviewer'],
};

export function hasCapability(user, capability) {
  return (CAPABILITIES[capability] || []).includes(user?.role);
}

// Scoped roles (intake_reviewer) are outside the hierarchy and never pass.
export function hasRole(user, minRole) {
  const level = ROLE_LEVELS[user?.role];
  if (level === undefined) return false;
  return level >= (ROLE_LEVELS[minRole] ?? Infinity);
}

export function can(user, permission) {
  return hasRole(user, PERMISSIONS[permission]);
}

// const can = usePermissions(); can('editWork')
export function usePermissions() {
  const { user } = useAuth();
  return (permission) => can(user, permission);
}
